export default __webpack_public_path__ + "static/media/venue-group.1ba3ece1.svg";